import * as Icons from "@phosphor-icons/react";

export function GetIcon(icon: string) {
  let Icon: any = Icons[icon as keyof typeof Icons];

  return Icon || Icons.Warning;
}
